// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__CeQGa","gfeWrapper":"CalendarEvent_gfeWrapper__1ajl7"};